<style lang="css" scope>
  .wz-comment-list {
    padding: 0.2rem;
  }
</style>
<template>
  <div class="wz-comment-list">
    <slot name="head"></slot>
    <div v-if="list && list.length" class="wz-comment-list__body">
      <wz-comment-item
        v-for="comment in list"
        :key="comment.cid"
        :comment="comment"
        :users="userMap"
      ></wz-comment-item>
    </div>
    <div v-else class="wz-comment-list__body">
      <k-no-data>暂无评论</k-no-data>
    </div>
    <slot name="foot"></slot>
  </div>
</template>

<script>
  import { commentList } from '../../api/g/comment'
  export default {
    name: 'wz-comment-list',
    data() {
      return {
        list: [],
        userMap: {}
      }
    },
    props: {
      objType: { type: [Number, String], default: 0 },
      objId: { type: [Number, String], default: 0 },
      start: { type: Number, default: 0 },
      pageNum: { type: Number, default: 20 },
      params: { type: Object, default: null }
    },
    computed: {
      query() {
        const { objType, objId, start, pageNum, params } = this
        return {
          ...params,
          totalFlag: 1,
          objType,
          objId,
          start,
          pageNum
        }
      }
    },
    methods: {
      user(uid) {
        return this.userMap[uid] || { uid: uid, nick: `xs_${uid}`, logoSrc: '' }
      },
      async fetch() {
        const { query } = this
        const { total, list, userMap } = await commentList(query)
        this.userMap = userMap || {}
        this.list = list || []
        // console.log(list)

        this.$emit('success', {
          query,
          total
        })
      }
    },
    watch: {
      query() {
        this.fetch()
      }
    },
    created() {
      this.fetch()
    },
    beforeDestroy() {}
  }
</script>
